export default __webpack_public_path__ + "../staticImages/sgt_geschenk-260.png";